import CrudCustom from '../../../libs/custom/CrudCustom';

let MasterMappingSpt1771Service = new CrudCustom('/mapping-spt-1771s');
export default MasterMappingSpt1771Service;
